import { TraffickingTableName } from '../../../constants';

export const tooltipMessage = (tableName: TraffickingTableName): string =>
  `Select ${tableName === TraffickingTableName.lineItems ? 'line items' : tableName} for multiple edit`;
